import cx from 'classnames';
// import gtag from 'ga-gtag';
import React, { useCallback, useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';

import { metaMagnetSvg } from '~/assets/images';

type Props = {};

type HashType = 'vision' | 'games' | 'partners';

const Header: React.FC<Props> = () => {
  const [hash, setHash] = useState<HashType>('vision');
  const [isShow, setIsShow] = useState<boolean>(false);

  const handleHash = useCallback((value: HashType) => {
    // if (value === 'vision') {
    //   gtag('event', 'click', {
    //     event_category: 'PC_menu',
    //     event_label: 'Vision',
    //   });
    // } else if (value === 'games') {
    //   gtag('event', 'click', {
    //     event_category: 'PC_menu',
    //     event_label: 'Games',
    //   });
    // } else {
    //   gtag('event', 'click', {
    //     event_category: 'PC_menu',
    //     event_label: 'Partners',
    //   });
    // }

    setHash(value);
    setIsShow(false);
  }, []);

  const handleMopbileHash = useCallback((value: HashType) => {
    // if (value === 'vision') {
    //   gtag('event', 'click', {
    //     event_category: 'MO_menu',
    //     event_label: 'Vision',
    //   });
    // } else if (value === 'games') {
    //   gtag('event', 'click', {
    //     event_category: 'MO_menu',
    //     event_label: 'Games',
    //   });
    // } else {
    //   gtag('event', 'click', {
    //     event_category: 'MO_menu',
    //     event_label: 'Partners',
    //   });
    // }

    setHash(value);
    setIsShow(false);
  }, []);

  const handleIsShow = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setIsShow(checked);
  }, []);

  return (
    <header className="header">
      <div className="headerWrap">
        <a href="/" className="logo">
          <img src={metaMagnetSvg} alt="" />
        </a>
        <nav className="desktop_nav" style={{ display: 'none' }}>
          <ul className="menu_wrap">
            <li className={cx('menu_item')}>
              <ScrollLink
                className="active"
                style={{ cursor: 'pointer' }}
                to="vision"
                spy
                smooth
                duration={1000}
                onClick={() => handleHash('vision')}
                activeClass="active"
              >
                Vision
              </ScrollLink>
            </li>
            {/* <li className={cx('menu_item')}>
              <ScrollLink
                style={{ cursor: 'pointer' }}
                to="games"
                spy
                smooth
                duration={1000}
                onClick={() => handleHash('games')}
                activeClass="active"
              >
                Games
              </ScrollLink>
            </li> */}
            <li className={cx('menu_item')}>
              <ScrollLink
                style={{ cursor: 'pointer' }}
                to="partners"
                spy
                smooth
                duration={1000}
                onClick={() => handleHash('partners')}
                activeClass="active"
              >
                Partners
              </ScrollLink>
            </li>
            {/* <li className={cx('menu_item')}>
              <a
                href="/C2X_Whitepaper_v1.0.0_2.pdf"
                target="_blank"
                rel="noreferrer"
              >
                WhitePaper
              </a>
            </li> */}
          </ul>
        </nav>
        <div className="menu_icon" style={{ display: 'none' }}>
          <input
            className="menu_icon-cheeckbox"
            type="checkbox"
            id="toggle"
            onChange={handleIsShow}
            checked={isShow}
          />
          <div className="menu_icon-bar">
            <span />
            <span />
          </div>
          <div
            className="open_nav_container"
            style={{
              display: isShow ? 'block' : 'none',
            }}
            onClick={() => setIsShow(false)}
          >
            <label htmlFor="menu_icon-cheeckbox" />
            <nav className="open_nav">
              <ul className="open_menu_wrap">
                <li
                  className={cx('open_menu_item', {
                    active: hash === 'vision',
                  })}
                >
                  <ScrollLink
                    to="vision"
                    spy
                    smooth
                    duration={1000}
                    onClick={() => handleMopbileHash('vision')}
                  >
                    Vision
                  </ScrollLink>
                </li>
                {/* <li
                  className={cx('open_menu_item', { active: hash === 'games' })}
                >
                  <ScrollLink
                    to="game"
                    spy
                    smooth
                    duration={1000}
                    onClick={() => handleMopbileHash('games')}
                  >
                    Games
                  </ScrollLink>
                </li> */}
                <li
                  className={cx('open_menu_item', {
                    active: hash === 'partners',
                  })}
                >
                  <ScrollLink
                    to="partners"
                    spy
                    smooth
                    duration={1000}
                    onClick={() => handleMopbileHash('partners')}
                  >
                    Partners
                  </ScrollLink>
                </li>
                {/* <li className={cx('open_menu_item')}>
                  <a
                    href="/C2X_Whitepaper_v1.0.0_2.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    WhitePaper
                  </a>
                </li> */}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
